/**
 * Merge booking-detail payment fields into a list/card booking object
 * so ops grids can update one card without refetching the full list.
 */
export function mergeBookingCardFromDetails(existing, details) {
  if (!existing || !details) return existing;

  const paymentSummary = details.payment_summary
    ? { ...details.payment_summary }
    : existing.payment_summary
      ? { ...existing.payment_summary }
      : null;

  const totalAmount = Number(
    paymentSummary?.total_amount ?? details.total_amount ?? existing.total_amount ?? 0,
  );
  const totalPaid = Number(
    paymentSummary?.total_paid ?? details.total_paid ?? existing.total_paid ?? 0,
  );
  const remainingAmount = Number(
    paymentSummary?.remaining_balance ??
      details.remaining_amount ??
      existing.remaining_amount ??
      0,
  );

  if (paymentSummary) {
    paymentSummary.total_amount = totalAmount;
    paymentSummary.total_paid = totalPaid;
    paymentSummary.remaining_balance = remainingAmount;
  }

  let restaurantSummary = details.restaurant_orders_summary;
  if (restaurantSummary && typeof restaurantSummary === 'object') {
    restaurantSummary = {
      has_orders: Boolean(restaurantSummary.has_orders),
      summary: restaurantSummary.summary || {
        total_amount: 0,
        paid_amount: 0,
        remaining_amount: 0,
      },
    };
  } else {
    restaurantSummary = existing.restaurant_orders_summary;
  }

  const statusValue =
    details.status_value ||
    details.status ||
    existing.status_value ||
    existing.status;

  return {
    ...existing,
    total_amount: totalAmount,
    total_paid: totalPaid,
    remaining_amount: remainingAmount,
    advance_amount:
      details.advance_amount != null ? details.advance_amount : existing.advance_amount,
    payment_status:
      details.payment_status ||
      paymentSummary?.payment_status ||
      existing.payment_status,
    payment_summary: paymentSummary || existing.payment_summary,
    restaurant_orders_summary: restaurantSummary,
    is_paid: details.is_paid != null ? details.is_paid : existing.is_paid,
    currency: details.currency || existing.currency,
    status: details.status != null ? details.status : existing.status,
    status_value: statusValue,
    status_display: details.status_display || existing.status_display,
  };
}

export function patchBookingInList(bookings, bookingId, details, normalizeId) {
  const id = typeof normalizeId === 'function' ? normalizeId(bookingId) : Number(bookingId);
  if (!id || !Array.isArray(bookings)) return bookings;

  let found = false;
  const next = bookings.map((booking) => {
    const bid = typeof normalizeId === 'function'
      ? normalizeId(booking?.id ?? booking?.booking_id)
      : Number(booking?.id ?? booking?.booking_id);
    if (bid !== id) return booking;
    found = true;
    return mergeBookingCardFromDetails(booking, details);
  });
  return found ? next : bookings;
}
